/* Локальная заглушка вместо платного @fortawesome/pro-light-svg-icons.
   Ищет одноимённую иконку в бесплатных наборах FontAwesome, для pro-only имён
   использует близкий бесплатный аналог, иначе отдаёт пустой квадрат. */
var solid = require('@fortawesome/free-solid-svg-icons');
var regular = require('@fortawesome/free-regular-svg-icons');

// Иконки, которых нет в бесплатных наборах -> ближайший аналог.
var ALIASES = {
  faScalpel: 'faUserMd',
  faBooksMedical: 'faBook',
  faFileChartLine: 'faChartLine',
  faChartScatter: 'faChartLine',
  faUserNurse: 'faUserMd',
  faRadiation: 'faBiohazard',
  faCheckDouble: 'faCheckDouble',
  faCalendarAlt: 'faCalendarAlt'
};
var blank = function blank(name) {
  return {
    prefix: 'fal',
    iconName: name.replace(/^fa/, '').replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase(),
    icon: [512, 512, [], 'f0c8', 'M64 64h384v384H64z']
  };
};
var resolve = function resolve(name) {
  var alias = ALIASES[name];
  return regular[name] || solid[name] || alias && (regular[alias] || solid[alias]) || blank(name);
};
var cache = new Map();
module.exports = new Proxy({}, {
  get: function get(_t, prop) {
    if (typeof prop !== 'string') return undefined;
    if (prop === '__esModule') return true;
    if (!cache.has(prop)) cache.set(prop, resolve(prop));
    return cache.get(prop);
  },
  has: function has() {
    return true;
  }
});